const BudgetKanbanSkeletonCard = () => (
  <div className="p-[10px] !h-auto w-full bg-[#D0DAE2]">
    <div
      className="w-full border border-gray-300 rounded-lg p-4 flex flex-col justify-between bg-[#E5EBF0]"
      style={{ height: "220px", borderWidth: "1.7px" }}
    >
      <div>
        <div className="flex justify-between items-center mb-3">
          <div className="h-[14px] w-[120px] animate-pulse rounded bg-gray-300" />
          <div className="h-[14px] w-[32px] animate-pulse rounded bg-gray-300" />
        </div>

        <div className="space-y-2 mb-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="flex justify-between">
              <div className="h-[14px] w-[80px] animate-pulse rounded bg-gray-300" />
              <div className="h-[14px] w-[100px] animate-pulse rounded bg-gray-300" />
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col mt-4 gap-2">
        <div className="h-[14px] w-[110px] animate-pulse rounded bg-gray-300" />
        <div className="h-[28px] w-full animate-pulse rounded-full bg-gray-300" />
      </div>
    </div>
  </div>
);

export default BudgetKanbanSkeletonCard;
